import { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

interface AgentOwnerLeadsProps extends SectionProps {}

export const AgentMarketing: FC<AgentOwnerLeadsProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return (
    <Can hasRoles={['agent']} hideFromZazumeUser>
      <NavigationLink
        to={Private.AGENTS_MARKETING.route}
        isMobile={isMobile}
        onClick={onClickItem}
        depth={depth}
        title={t('general.marketing')}
        icon="marketplace"
      />
    </Can>
  );
};
